/**
 * descriptionSnippets Normalizr Schema
 */

import { schema } from 'normalizr';

const descriptionSnippet = new schema.Entity('descriptionSnippets');

export default descriptionSnippet;
